/**
 * Tipo do veículo cadastrado (2026-10-27) — espelho de
 * `core.vocabulary.VEHICLE_KINDS`, com paridade travada por
 * `tests/test_vehicle_kind_parity.py` (lê este arquivo, inclusive a
 * SEQUÊNCIA, que é a ordem do `<select>`). O `press` antigo foi dividido
 * em `print` e `online`; o resto do legado é `online`. O mapa de rótulos é
 * tipado sobre a tupla de propósito: chave a menos ou a mais é erro de
 * compilação, não uma opção sem nome na tela.
 */

export const VEHICLE_KINDS = ["print", "online", "tv", "radio"] as const;

export type VehicleKind = (typeof VEHICLE_KINDS)[number];

export const VEHICLE_KIND_DEFAULT: VehicleKind = "online";

export const VEHICLE_KIND_LABELS: Record<VehicleKind, string> = {
  print: "Impresso",
  online: "Online",
  tv: "TV",
  radio: "Rádio"
};

/**
 * O rótulo que separa veículos com o mesmo nome (2026-11-03): "Band · SP ·
 * TV". Espelho de `core/vehicle_identity.py::vehicle_label` — UF e tipo
 * saem quando ausentes. Use em toda lista ou seletor de veículo: com
 * homônimos, só o nome mostraria duas opções iguais.
 */
export function vehicleLabel(vehicle: {
  name: string;
  state?: string | null;
  vehicle_kind?: string | null;
}): string {
  const parts = [vehicle.name];
  const state = vehicle.state?.trim();
  if (state) parts.push(state);
  const kind = VEHICLE_KIND_LABELS[vehicle.vehicle_kind as VehicleKind];
  if (kind) parts.push(kind);
  return parts.join(" · ");
}
